import { Injectable, inject } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ConfigurationBackend } from "src/app/backend/api/configuration.backend";
import { ConfigurationService } from "src/app/services/configuration.service";

@Injectable()
export class ProvideWarehouseConfigurationGuard {
  private readonly configurationService = inject(ConfigurationService);
  private readonly configurationBackend = inject(ConfigurationBackend);

  async canActivate(): Promise<boolean> {
    const configuration = await lastValueFrom(
      this.configurationBackend.loadWarehouse()
    );

    if (configuration) {
      this.configurationService.warehouse.set(configuration);
    }

    return true;
  }
}
